import React, { useState } from "react";
import Common_Back_Btn from "../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Common_Report_Offcanvas from "../../common_report_offcanvas/Common_Report_Offcanvas";
import { Nav, Tab } from "react-bootstrap";
import Internal_Audit from "./inner_tabs/internal_audit/Internal_Audit";
import MRM from "./inner_tabs/mrm/MRM";
import Risk from "./inner_tabs/risk/Risk";

const Management_System = () => {
  const [show, setShow] = useState(false);

  const tabs = ["Internal Audit", "MRM", "Risk & Opportunities"];

  return (
    <section className="Sample_Report">
      <div className="back_div">
        <Common_Back_Btn backText="Resource Requirement" />
      </div>

      <div className="tables_tab_section">
        <Tab.Container id="left-tabs-example" defaultActiveKey={tabs[0]}>
          <Nav variant="pills" className="">
            {tabs?.map((item) => {
              return (
                <Nav.Item>
                  <Nav.Link eventKey={item}>{item}</Nav.Link>
                </Nav.Item>
              );
            })}
          </Nav>

          <Tab.Content className="inner-tab-sec">
            <Tab.Pane eventKey="Internal Audit">
              <Internal_Audit />
            </Tab.Pane>
            <Tab.Pane eventKey="MRM">
              <MRM />
            </Tab.Pane>
            <Tab.Pane eventKey="Risk & Opportunities">
              <Risk />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>

      <Common_Report_Offcanvas
        title={"Resource Requirement"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default Management_System;
